import { render } from "./forgot-password.vue?vue&type=template&id=7d2ebed3&ts=true"
import script from "./forgot-password.vue?vue&type=script&lang=ts"
export * from "./forgot-password.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__